module.exports = __webpack_public_path__ + "img/06.c540323e.png";